module.exports = __webpack_public_path__ + "static/media/sendMessage.8222e7bc.png";